import { ActionIcon, Anchor, CopyButton, Group, HoverCard, Stack, Text, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy, IconFingerprint } from "@tabler/icons-react";
import { Link } from "react-router-dom";

/** The call's `X-Request-ID`, with what it's for: rating the result later via POST /napi/feedback. */
export function RequestIdChip({ id }: { id?: string }) {
  if (!id) return null;
  const short = id.length > 14 ? `${id.slice(0, 8)}…${id.slice(-4)}` : id;
  return (
    <HoverCard width={320} position="bottom-start" withArrow shadow="md" openDelay={150}>
      <HoverCard.Target>
        <Group gap={4} wrap="nowrap" px={8} py={2} style={{ border: "1px dashed var(--mantine-color-default-border)", borderRadius: 99, cursor: "help" }}>
          <IconFingerprint size={13} color="var(--pd-violet)" />
          <Text fz={11} ff="monospace" c="dimmed">
            {short}
          </Text>
          <CopyButton value={id}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? "Copied" : "Copy request ID"}>
                <ActionIcon size={16} variant="transparent" color={copied ? "lime.8" : "gray"} onClick={copy} aria-label="Copy request ID">
                  {copied ? <IconCheck size={12} /> : <IconCopy size={12} />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
        </Group>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Stack gap={6}>
          <Text fz="sm" fw={700}>
            Request ID
          </Text>
          <Text fz="xs" ff="monospace" style={{ wordBreak: "break-all" }}>
            {id}
          </Text>
          <Text fz="xs" c="dimmed">
            Every call returns a unique <code>X-Request-ID</code> header. Keep it with the result in your app. When the user logs, edits or throws the result away, send that outcome to <code>POST /napi/feedback</code> with this ID. Rating isn't billed, and it tunes the route to your users.
          </Text>
          <Anchor component={Link} to="/guide#feedback" fz="xs" fw={600}>
            How rating works, with code
          </Anchor>
        </Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
